/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import theme from '../../../../../Shared/Themes/theme';

export const styles = {
  addButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #006B6B',
    borderRadius: '14px',
    padding: '10px 14px',
    cursor: 'pointer',
    width: '100%',
    maxWidth: '9rem',
  },
  addButtonText: {
    color: '#006B6B',
    letterSpacing: '0.25px',
    fontSize: theme.typography.h5?.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    flexDirection: 'row' as const,
  },
  taskContainer: {
    position: 'relative' as const,
    overflow: 'visible' as const,
    display: 'flex',
    flexDirection: 'column' as const,
    padding: '0.5rem 1rem',
    border: '2px solid #e5e7eb',
    borderRadius: '1rem',
    cursor: 'pointer',
    width: '45%',
  },
  expandedTaskPanel: {
    gap: 1.2,
    position: 'absolute' as const,
    top: '100%',
    left: 0,
    width: '100%',
    background: 'white',
    border: '1px solid #e5e7eb',
    borderRadius: '10px',
    padding: '1rem',
    boxShadow: '0 10px 20px rgba(0,0,0,0.12)',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column' as const,
  },
  subTaskItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: 1.2,
    border: '1px solid #e5e7eb',
    borderRadius: '6px',
    backgroundColor: '#fafafa',
  },
  sectionTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.h3?.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: '1rem',
  },
  createNewLink: {
    color: '#006B6B',
    letterSpacing: '0.25px',
    fontSize: theme.typography.h5?.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    flexDirection: 'row' as const,
    alignItems: 'center',
    gap: 0.5,
  },
  addNewLink: {
    color: '#006B6B',
    letterSpacing: '0.25px',
    fontSize: theme.typography.h5?.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    flexDirection: 'row' as const,
    alignItems: 'center',
    gap: 0.5,
  },

  taskChip: {
    background: '#f3f4f6',
    padding: '6px 12px',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    '&:hover': { background: '#e5e7eb' },
  },
  taskDropdown: {
    position: 'absolute' as const,
    top: '2rem',
    left: 0,
    background: 'white',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    borderRadius: '10px',
    padding: '0.6rem 0.9rem',
    zIndex: 10,
    minWidth: '100%',
  },
  dropdownItem: {
    padding: '4px 0',
    fontSize: '0.9rem',
    color: '#374151',
    cursor: 'pointer',
    '&:hover': { background: '#f9fafb' },
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #006B6B',
    borderRadius: '14px',
    padding: '10px 14px',
    width: '100%',
    maxWidth: '10rem',
  },
  actionButtonText: {
    color: '#006B6B',
    letterSpacing: '0.25px',
    fontSize: theme.typography.h5?.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: theme.typography.fontFamily,
  },

  dropdownStyles: {
    width: '22.5rem',
    '& .MuiInputBase-root': {
      paddingRight: '0.75rem !important',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset,&:hover fieldset,&.Mui-focused fieldset': {
        borderWidth: 1,
        borderColor: theme.palette.secondary.light,
        borderRadius: '1rem',
      },
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.h4?.fontSize,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightRegular,
      '&.Mui-focused': {
        color: theme.palette.text.secondary,
        fontSize: theme.typography.h5?.fontSize,
      },
      '&.MuiInputLabel-shrink': {
        fontSize: theme.typography.h5?.fontSize,
      },
    },
  },
};
